import type { ReactNode } from "react";

export interface ContainerProps {
  children: ReactNode;
  className?: string;
}

/** The one content width: header band, page content and landing sections all share it. */
export function Container({ children, className = "" }: ContainerProps) {
  return <div className={`mx-auto w-full max-w-5xl px-4 md:px-6 ${className}`}>{children}</div>;
}
